import { useTranslation } from 'react-i18next'
import { CarrierDocsInfo } from 'views/pages/LogisticsKR/types'

type Props = { docsInfo: CarrierDocsInfo }
export const DocCell = ({ docsInfo }: Props) => {
  const { t } = useTranslation('logisticsKR')
  if (docsInfo.car) {
    return (
      <div>
        {t('car')}
        <div>
          {docsInfo.car.brand_model} {docsInfo.car.licence_number}
        </div>
      </div>
    )
  } else if (docsInfo.trailer) {
    return (
      <div>
        {t('trailer')}
        <div>
          {docsInfo.trailer.brand_model} {docsInfo.trailer.licence_number}
        </div>
      </div>
    )
  } else if (docsInfo.driver) {
    return (
      <div>
        {t('driver')} <div>{docsInfo.driver.name}</div>
      </div>
    )
  } else {
    return (
      <div>
        {t('carrier')} <div>{docsInfo.carrier.name}</div>
      </div>
    )
  }
  return
}
